export default __webpack_public_path__ + "static/media/undraw_Photograph_re_up3b (1).cc221ac9.svg";